import { ContactSupportReason } from '@enums/contact-support-reason.enum';

export const CONTACT_SUPPORT_REASON_LABEL: Record<ContactSupportReason, string> = {
  [ContactSupportReason.question]: `J'ai une question sur Expert`,
  [ContactSupportReason.idea]: `J'ai une idée`,
  [ContactSupportReason.apps]: `J'ai une question sur les apps`,
  [ContactSupportReason.subscription]: `Modifier l’abonnement de mon client`
};
